import React from "react";
import { Col, Row, Space, Typography } from "antd";
import { DatePicker } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { setFinanceResellerDates } from "store/bailiff/finance/reseller/finance_reseller.action";
import { financeResellerDatesSelector } from "store/bailiff/finance/reseller/finance_reseller.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const { RangePicker } = DatePicker;

const HistoryHeader = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const dates = useSelector(financeResellerDatesSelector);
  // -------------------------- FUNCTION ------------------------
  const handleChange = (dates) => {
    dispatch(setFinanceResellerDates(dates));
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row gutter={[10, 10]}>
        <Col xl={12} lg={12} md={24} xs={24}>
          <Typography.Title style={{ margin: "10px 0px" }} level={4}>
            Lịch sử nhận tiền
          </Typography.Title>
          <Typography.Text type="secondary">
            Số tiền bạn nhận được từ việc làm nhiệm vụ
          </Typography.Text>
        </Col>
        <Col
          style={{ display: "flex", alignItems: "end", justifyContent: "end" }}
          xl={12}
          lg={12}
          md={24}
          xs={24}
        >
          {renderSelectRange()}
        </Col>
      </Row>
    );
  };

  const renderSelectRange = () => {
    return (
      <RangePicker
        value={dates}
        onChange={handleChange}
        placeholder={["Từ ngày", "Đến ngày"]}
      />
    );
  };

  // -------------------------- MAIN ----------------------------
  return <div style={{ padding: 15 }}>{renderBody()}</div>;
};
export default HistoryHeader;
